import { jsx as e, jsxs as W, Fragment as vt } from "react/jsx-runtime";
import { faSchoolFlag as Qt } from "@fortawesome/pro-regular-svg-icons/faSchoolFlag";
import { faSuitcase as Kt } from "@fortawesome/pro-regular-svg-icons/faSuitcase";
import { faUser as Vt } from "@fortawesome/pro-solid-svg-icons/faUser";
import Pt from "@mui/material/Avatar";
import L from "classnames";
import { createTheme as te, ThemeProvider as ee } from "@mui/material/styles";
import mt, { useState as ht, forwardRef as oe, useRef as ne } from "react";
import { faCaretDown as re } from "@fortawesome/pro-solid-svg-icons/faCaretDown";
import { Tooltip as ae, Popover as Ut, Box as ie, Typography as le } from "@mui/material";
import { faArrowDownToLine as se } from "@fortawesome/pro-regular-svg-icons/faArrowDownToLine";
import { faLoader as ce } from "@fortawesome/pro-regular-svg-icons/faLoader";
import { faLock as de } from "@fortawesome/pro-regular-svg-icons/faLock";
import { faPencil as fe } from "@fortawesome/pro-regular-svg-icons/faPencil";
import { faPlus as ue } from "@fortawesome/pro-regular-svg-icons/faPlus";
import { faTrashCan as me } from "@fortawesome/pro-regular-svg-icons/faTrashCan";
import { faArrowRight as he } from "@fortawesome/pro-solid-svg-icons/faArrowRight";
import { faChevronDown as ge } from "@fortawesome/pro-solid-svg-icons/faChevronDown";
import { faChevronRight as be } from "@fortawesome/pro-solid-svg-icons/faChevronRight";
import { Link as Ct } from "react-router-dom";
import { dayjsLocalizer as pe, Calendar as ye } from "react-big-calendar";
import { faChevronLeft as Rt } from "@fortawesome/pro-regular-svg-icons/faChevronLeft";
import { FontAwesomeIcon as _e } from "@fortawesome/react-fontawesome";
import { faCircleMinus as xe, faTriangleExclamation as we, faHourglass as ve, faCircleCheck as Se } from "@fortawesome/pro-solid-svg-icons";
import ke from "@mui/material/IconButton";
import { faCircleCheck as Me } from "@fortawesome/pro-regular-svg-icons/faCircleCheck";
import { faCircleInfo as $e } from "@fortawesome/pro-regular-svg-icons/faCircleInfo";
import { faHandWave as Ce } from "@fortawesome/pro-regular-svg-icons/faHandWave";
import { faHourglassHalf as De } from "@fortawesome/pro-regular-svg-icons/faHourglassHalf";
import { faLightbulbOn as Le } from "@fortawesome/pro-regular-svg-icons/faLightbulbOn";
import { faOctagonExclamation as We } from "@fortawesome/pro-regular-svg-icons/faOctagonExclamation";
import { faTriangleExclamation as Te } from "@fortawesome/pro-regular-svg-icons/faTriangleExclamation";
import { faXmark as Be } from "@fortawesome/pro-regular-svg-icons/faXmark";
import Gt from "react-spinkit";
import Fe from "@mui/material/Paper";
import V from "@mui/material/Skeleton";
import { faLoader as Oe } from "@fortawesome/pro-solid-svg-icons/faLoader";
import ze from "@mui/material/TextField";
import Ne from "@mui/material/InputAdornment";
import { faEye as Re } from "@fortawesome/pro-regular-svg-icons/faEye";
import { faEyeSlash as He } from "@fortawesome/pro-regular-svg-icons/faEyeSlash";
import Lt from "@mui/material/useMediaQuery";
import '../index.css';const Mt = {
  xxl: {
    width: 64,
    height: 64,
    icon: "2xl"
  },
  xl: {
    width: 56,
    height: 56,
    icon: "xl"
  },
  lg: {
    width: 48,
    height: 48,
    icon: "lg"
  },
  md: {
    width: 40,
    height: 40,
    /**
     * 'md' is not a valid size for FontAwesomeIcon.
     * When undefined is passed to FontAwesomeIcon as a size value,
     * the icon will default to the current font size of its parent element.
     */
    icon: void 0
  },
  sm: {
    width: 32,
    height: 32,
    icon: "sm"
  },
  xs: {
    width: 24,
    height: 24,
    icon: "xs"
  },
  xxs: {
    width: 16,
    height: 16,
    icon: "2xs"
  }
}, Ae = ({
  size: t = "md",
  children: o,
  fallback: r,
  alt: n
}) => {
  if (o)
    return o;
  switch (r) {
    case "person":
      return /* @__PURE__ */ e(F, { icon: Vt, size: Mt[t].icon, alt: n });
    case "school":
      return /* @__PURE__ */ e(
        F,
        {
          icon: Qt,
          size: Mt[t].icon,
          alt: n
        }
      );
    case "employer":
      return /* @__PURE__ */ e(F, { icon: Kt, size: Mt[t].icon, alt: n });
    default:
      return null;
  }
}, ni = ({
  children: t = void 0,
  fallback: o = "person",
  size: r = "md",
  ...n
}) => /* @__PURE__ */ e(Pt, { sx: Mt[r], ...n, children: Ae({ size: r, fallback: o, children: t, alt: n.alt }) }), Ht = {}, Ee = (t) => t.replace(/([a-z])([A-Z])/g, "$1 $2").replace(/(\d)([a-zA-Z])/g, "$1 $2").replace(/([a-zA-Z])(\d)/g, "$1 $2").replace(/[^a-zA-Z0-9]+/g, " ").trim().toLowerCase().replace(/\s+/g, "-"), Ie = (t) => t.replace(/([a-z])([A-Z])/g, "$1 $2").replace(/[^a-zA-Z0-9]+/g, " ").trim().toLowerCase().replace(
  /(?:\s+|^)(\w)/g,
  (o, r, n) => n === 0 ? r : r.toUpperCase()
).replace(/\s+/g, ""), rt = {
  black: "#000",
  blackV2: "#1e1a12",
  white: "#fff",
  font: "#363636",
  brandClever: "#4271f6",
  brandOneroster: "#0f4d87",
  blue: "#4397ea",
  blueBg: "#f5fbff",
  blueDark: "#2386e7",
  blueXtraDark: "#1477d8",
  blueContrastDark: "#124577",
  blueExtraLight: "#e6f3fa",
  blueLight: "#c4e1f2",
  blueMedium: "#68aaee",
  blueSteel: "#728dac",
  blueSteelDark: "#5f7ea0",
  blueSteelXtraDark: "#516d8f",
  blueSteelContrastDark: "#3a4e66",
  blueSteelExtraLight: "#e1e7ed",
  blueSteelLight: "#cbdaeb",
  blueSteelMedium: "#8da7c4",
  gray: "#999",
  grayBg: "#f6f6f6",
  grayDark: "#6f6f6f",
  grayDarkV2: "#71726e",
  grayXtraDark: "#595959",
  grayExtraLight: "#eee",
  grayLight: "#dbdbdb",
  grayMedium: "#bebdbd",
  green: "#5aa43d",
  greenBg: "#fbfff4",
  greenDark: "#429617",
  greenXtraDark: "#268900",
  greenContrastDark: "#1c6400",
  greenExtraLight: "#f1f6e6",
  greenLight: "#ddedc9",
  greenMedium: "#7db866",
  indigo: "#7180d6",
  indigoDark: "#5d6ed0",
  indigoXtraDark: "#5364c6",
  indigoContrastDark: "#394799",
  indigoExtraLight: "#e6e9f8",
  indigoLight: "#b7c3ff",
  indigoMedium: "#8c99e3",
  orange: "#ff8000",
  orangeDark: "#f07000",
  orangeXtraDark: "#d66000",
  orangeContrastDark: "#99430d",
  orangeExtraLight: "#feedd5",
  orangeLight: "#ffd9b8",
  orangeMedium: "#fc9b5f",
  purple: "#9974dc",
  purpleDark: "#8d64d8",
  purpleXtraDark: "#8861cf",
  purpleContrastDark: "#583cbd",
  purpleExtraLight: "#ede8f8",
  purpleLight: "#d9c4ff",
  purpleMedium: "#ae8fea",
  red: "#e46658",
  redDark: "#d85446",
  redXtraDark: "#d24536",
  redContrastDark: "#9e2518",
  redExtraLight: "#ffe9e9",
  redLight: "#ffb3ab",
  redMedium: "#f67c6f",
  teal: "#16a2a2",
  tealDark: "#149090",
  tealDarkV2: "#2b7383",
  tealXtraDark: "#128484",
  tealContrastDark: "#0a5656",
  tealExtraLight: "#e3f4f2",
  tealLight: "#cceaea",
  tealLightV2: "#ecf5f7",
  tealMedium: "#62bcbc",
  violet: "#c863d9",
  violetDark: "#c253d5",
  violetXtraDark: "#ba3dd0",
  violetContrastDark: "#752383",
  violetExtraLight: "#f5e9f7",
  violetLight: "#f6c8ff",
  violetMedium: "#d68ce3",
  pink: "#d85a8c",
  pinkDark: "#cc3e76",
  pinkXtraDark: "#ba2c65",
  pinkContrastDark: "#811d45",
  pinkExtraLight: "#ffebf3",
  pinkLight: "#ffcce0",
  pinkMedium: "#fbb1cf",
  yellow: "#fad961",
  yellowV2: "#f5ec1e",
  yellowDark: "#f5c614",
  yellowXtraDark: "#eebc04",
  yellowContrastDark: "#986f15",
  yellowContrastLight: "#ffffef",
  yellowExtraLight: "#fff7da",
  yellowLight: "#ffefb7",
  yellowLightV2: "#fbfbca",
  yellowMedium: "#fbdf78",
  yellowTextDark: "#b28d02"
}, je = {
  base: "'Halis Rounded', 'Segoe UI', 'HelveticaNeue-Light', 'Roboto', sans-serif",
  baseV2: "'GT Flexa', 'Segoe UI', 'HelveticaNeue-Light', 'Roboto', sans-serif",
  body: "'Roboto', 'Segoe UI', 'HelveticaNeue-Light', sans-serif",
  code: "'Roboto Mono', 'Segoe UI', 'HelveticaNeue-Light', sans-serif",
  signature: "'Sofia', cursive",
  emoji: "emoji"
}, Xe = {
  robotoLight: 300,
  robotoRegular: 400,
  robotoMedium: 500,
  robotoBold: 700,
  robotoBlack: 900,
  halisThin: 100,
  halisLight: 300,
  halisBook: 400,
  halisRegular: 500,
  halisMedium: 600,
  halisBold: 700,
  halisBlack: 800
}, Ye = {
  iconXxs: "10px",
  iconXs: "12px",
  iconXtSm: "14px",
  iconSm: "16px",
  iconMd: "20px",
  iconLg: "24px",
  iconXl: "32px",
  iconXxl: "40px",
  fontSizeTitleLg: "64px",
  fontSizeTitle: "26px",
  fontSizeTitleSm: "24px",
  fontSizeTitleXs: "22px",
  fontSizeLg: "20px",
  fontSizeMd: "18px",
  fontSizeSm: "16px",
  fontSizeXs: "14px",
  fontSizeXxs: "12px",
  fontSizeXxxs: "10px",
  fontSizeEmoji: "32px",
  appbarHeight: "64px",
  sidebarWidth: "64px",
  subnavHeight: "48px",
  containerBorderWidth: "2px",
  containerBorderRadiusLarge: "32px",
  containerBorderRadiusMedium: "16px",
  containerBorderRadius: "8px",
  containerBorderRadiusXtSmall: "6px",
  containerBorderRadiusSmall: "4px",
  containerBorderRadiusTop: "8px 8px 0 0",
  containerBorderRadiusBottom: "0 0 8px 8px",
  containerBorderRadiusLeft: "8px 0 0 8px",
  containerBorderRadiusRight: "0 8px 8px 0",
  containerBorderRadiusTopLeft: "8px 0 0 0",
  containerBorderRadiusTopRight: "0 8px 0 0",
  containerBorderRadiusBottomLeft: "0 0 0 8px",
  containerBorderRadiusBottomRight: "0 0 8px 0",
  contentHeight: "calc(100vh - 64px)",
  chatBorderRadiusTopLeft: "2px 16px 16px 16px",
  shadow: "0 2px 10px 0 rgba(0, 0, 0, 0.15)",
  shadowTop: "0 -2px 10px 0 rgba(0, 0, 0, 0.15)",
  shadowExtraLight: "0 1px 5px rgba(0, 0, 0, 0.12)",
  shadowLight: "0 0 5px 0 rgba(0, 0, 0, 0.15)",
  shadowMedium: "0 4px 12px rgba(0, 0, 0, 0.3)",
  shadowStrong: "0 2px 60px 0 rgba(0, 0, 0, 0.2)",
  shadowInset: "inset 0 0 5px 0 rgba(0, 0, 0, 0.1)",
  shadowBottom: "0px 10px 10px -6px rgba(0, 0, 0, 0.15)",
  shadowBlue: "0px 0px 0px 2px rgba(18, 69, 119, 0.40)",
  shadowGray: "0px 0px 0px 2px rgba(190, 189, 189, 0.40)",
  shadowRed: "0px 0px 0px 2px rgba(158, 37, 24, 0.40)",
  shadowFont: "0px 2px 0px 0px #363636"
}, Ue = {
  tt: "1px",
  tiny: "2px",
  xxs: "4px",
  xs: "8px",
  xtSm: "10px",
  input: "10.5px",
  sm: "12px",
  md: "16px",
  xtMd: "24px",
  lg: "32px",
  xl: "40px",
  xxl: "48px"
}, Ge = {
  defaultGray: `2px solid ${rt.gray}`,
  defaultGrayLight: `1px solid ${rt.grayLight}`,
  defaultGrayMedium: `1px solid ${rt.grayMedium}`,
  defaultGrayExtraLight: `1px solid ${rt.grayExtraLight}`,
  defaultBlue: `1px solid ${rt.blue}`,
  defaultBlueDark: `2px solid ${rt.blueDark}`,
  defaultRed: `2px solid ${rt.red}`,
  focusBlue: `2px solid ${rt.blue}`,
  white: `1px solid ${rt.white}`
}, qe = {
  widthXs: "520px",
  widthSm: "640px",
  widthMd: "760px",
  widthLg: "880px",
  widthXl: "960px"
}, xt = {
  mobileMin: "320px",
  mobileMax: "560px",
  tabletMin: "561px",
  tabletMax: "1020px",
  desktopMin: "1021px"
}, Ze = {
  blue: "3px solid rgba(20, 119, 216, 0.75)",
  gray: "3px solid rgba(89, 89, 89, 0.75)",
  red: "3px solid rgba(210, 70, 54, 0.75)",
  green: "3px solid rgba(38, 137, 0, 0.76)"
}, a = {
  color: rt,
  fontFamily: je,
  fontWeight: Xe,
  schoolinks: Ye,
  spacing: Ue,
  border: Ge,
  modal: qe,
  breakpoint: xt,
  focusOutline: Ze
}, Je = `@import './gtflexa.css';
@import './halisrounded.css';
/* 
* This file is auto-generated by running "yarn run build" (not "yarn run dev"). 
* Do not edit this file directly as changes will be overwritten.
* Add or update variables in src/utils/variables.js.
*/`, Qe = (t) => {
  const o = [];
  for (const r in t) {
    const n = Ee(r), f = t[r];
    for (const i in f) {
      const d = i.replace(/([a-z])([A-Z0-9])/g, "$1-$2").toLowerCase(), u = `--${n}-${d}`, p = f[i];
      o.push(`${u}: ${p};`);
    }
  }
  return `${Je}
:root {
${o.map((r) => `  ${r}`).join(`
`)}
}
`;
}, ri = () => {
  let t = !1;
  return {
    name: "generate-css-vars",
    apply: "build",
    config(o) {
      var r;
      (r = o.build) != null && r.watch && (t = !0);
    },
    buildStart() {
      if (t)
        return;
      console.log("Generating CSS variables...");
      const o = Qe(a), r = Ht.resolve("./src/utils/variables.css");
      Ht.writeFileSync(r, o, "utf-8"), console.log(`CSS variables written to ${r}`);
    }
  };
}, Ke = {
  lead400: {
    fontSize: 18,
    fontFamily: a.fontFamily.base,
    fontWeight: a.fontWeight.halisBook,
    fontStyle: "normal",
    lineHeight: "22px"
  },
  lead500: {
    fontSize: 18,
    fontFamily: a.fontFamily.base,
    fontWeight: a.fontWeight.halisRegular,
    fontStyle: "normal",
    lineHeight: "22px"
  },
  lead700: {
    fontSize: 18,
    fontFamily: a.fontFamily.base,
    fontWeight: a.fontWeight.halisBold,
    fontStyle: "normal",
    lineHeight: "22px"
  },
  titleMd500: {
    fontSize: 16,
    fontFamily: a.fontFamily.base,
    fontWeight: a.fontWeight.halisRegular,
    fontStyle: "normal",
    lineHeight: "20px"
  },
  titleMd700: {
    fontSize: 16,
    fontFamily: a.fontFamily.base,
    fontWeight: a.fontWeight.halisBold,
    fontStyle: "normal",
    lineHeight: "20px"
  },
  titleSm500: {
    fontSize: 14,
    fontFamily: a.fontFamily.base,
    fontWeight: a.fontWeight.halisRegular,
    fontStyle: "normal",
    lineHeight: "16px"
  },
  titleSm700: {
    fontSize: 14,
    fontFamily: a.fontFamily.base,
    fontWeight: a.fontWeight.halisBold,
    fontStyle: "normal",
    lineHeight: "16px"
  },
  bodyMd400: {
    fontSize: 16,
    fontFamily: a.fontFamily.body,
    fontWeight: a.fontWeight.robotoRegular,
    fontStyle: "normal",
    lineHeight: "20px"
  },
  bodyMd500: {
    fontSize: 16,
    fontFamily: a.fontFamily.body,
    fontWeight: a.fontWeight.robotoMedium,
    fontStyle: "normal",
    lineHeight: "20px"
  },
  bodyMd600: {
    fontSize: 16,
    fontFamily: a.fontFamily.body,
    fontWeight: a.fontWeight.robotoMedium,
    fontStyle: "normal",
    lineHeight: "20px"
  },
  bodyMd700: {
    fontSize: 16,
    fontFamily: a.fontFamily.body,
    fontWeight: a.fontWeight.robotoBold,
    fontStyle: "normal",
    lineHeight: "20px"
  },
  bodySm400: {
    fontSize: 14,
    fontFamily: a.fontFamily.body,
    fontWeight: a.fontWeight.robotoRegular,
    fontStyle: "normal",
    lineHeight: "16px"
  },
  bodySm500: {
    fontSize: 14,
    fontFamily: a.fontFamily.body,
    fontWeight: a.fontWeight.robotoMedium,
    fontStyle: "normal",
    lineHeight: "16px"
  },
  bodySm600: {
    fontSize: 14,
    fontFamily: a.fontFamily.body,
    fontWeight: a.fontWeight.robotoMedium,
    fontStyle: "normal",
    lineHeight: "16px"
  },
  bodySm700: {
    fontSize: 14,
    fontFamily: a.fontFamily.body,
    fontWeight: a.fontWeight.robotoBold,
    fontStyle: "normal",
    lineHeight: "16px"
  },
  meta400: {
    fontSize: 12,
    fontFamily: a.fontFamily.body,
    fontWeight: a.fontWeight.robotoRegular,
    fontStyle: "normal",
    lineHeight: "14px"
  },
  meta700: {
    fontSize: 12,
    fontFamily: a.fontFamily.body,
    fontWeight: a.fontWeight.robotoBold,
    fontStyle: "normal",
    lineHeight: "14px"
  },
  label: {
    fontSize: 12,
    fontFamily: a.fontFamily.body,
    fontWeight: a.fontWeight.robotoMedium,
    fontStyle: "normal",
    lineHeight: "14px"
  },
  tiny: {
    fontSize: 10,
    fontFamily: a.fontFamily.body,
    fontWeight: a.fontWeight.robotoMedium,
    fontStyle: "normal",
    lineHeight: "12px"
  },
  mono: {
    fontSize: 14,
    fontFamily: a.fontFamily.code,
    fontWeight: "bolder",
    fontStyle: "normal",
    letterSpacing: "0.5px",
    lineHeight: "16px"
  },
  cursive: {
    fontSize: 16,
    fontFamily: a.fontFamily.signature,
    fontWeight: "bolder",
    fontStyle: "normal",
    letterSpacing: "0.5px",
    lineHeight: "18px"
  },
  stat1: {
    fontSize: 40,
    fontFamily: a.fontFamily.body,
    fontWeight: a.fontWeight.robotoBold,
    fontStyle: "normal",
    letterSpacing: "0.5px",
    lineHeight: "46px"
  },
  stat2: {
    fontSize: 34,
    fontFamily: a.fontFamily.body,
    fontWeight: a.fontWeight.robotoBold,
    fontStyle: "normal",
    letterSpacing: "0.5px",
    lineHeight: "38px"
  },
  stat3: {
    fontSize: 30,
    fontFamily: a.fontFamily.body,
    fontWeight: a.fontWeight.robotoBold,
    fontStyle: "normal",
    letterSpacing: "0.5px",
    lineHeight: "34px"
  },
  stat4: {
    fontSize: 26,
    fontFamily: a.fontFamily.body,
    fontWeight: a.fontWeight.robotoBold,
    fontStyle: "normal",
    letterSpacing: "0.5px",
    lineHeight: "30px"
  },
  stat5: {
    fontSize: 22,
    fontFamily: a.fontFamily.body,
    fontWeight: a.fontWeight.robotoBold,
    fontStyle: "normal",
    letterSpacing: "0.5px",
    lineHeight: "26px"
  },
  stat6: {
    fontSize: 20,
    fontFamily: a.fontFamily.body,
    fontWeight: a.fontWeight.robotoBold,
    fontStyle: "normal",
    letterSpacing: "0.5px",
    lineHeight: "24px"
  },
  h1: {
    fontSize: 40,
    fontFamily: a.fontFamily.base,
    fontWeight: a.fontWeight.halisMedium,
    fontStyle: "normal",
    lineHeight: "46px"
  },
  h2: {
    fontSize: 34,
    fontFamily: a.fontFamily.base,
    fontWeight: a.fontWeight.halisMedium,
    fontStyle: "normal",
    lineHeight: "38px"
  },
  h3: {
    fontSize: 30,
    fontFamily: a.fontFamily.base,
    fontWeight: a.fontWeight.halisMedium,
    fontStyle: "normal",
    lineHeight: "34px"
  },
  h4: {
    fontSize: 26,
    fontFamily: a.fontFamily.base,
    fontWeight: a.fontWeight.halisMedium,
    fontStyle: "normal",
    lineHeight: "30px"
  },
  h5: {
    fontSize: 22,
    fontFamily: a.fontFamily.base,
    fontWeight: a.fontWeight.halisMedium,
    fontStyle: "normal",
    lineHeight: "26px"
  },
  h6: {
    fontSize: 20,
    fontFamily: a.fontFamily.base,
    fontWeight: a.fontWeight.halisMedium,
    fontStyle: "normal",
    lineHeight: "24px"
  },
  body1: {
    fontSize: 16,
    fontFamily: a.fontFamily.body,
    fontWeight: a.fontWeight.robotoRegular,
    fontStyle: "normal",
    lineHeight: "19px"
  },
  body2: {
    fontSize: 14,
    fontFamily: a.fontFamily.body,
    fontWeight: a.fontWeight.robotoRegular,
    fontStyle: "normal",
    lineHeight: "16px"
  },
  caption: {
    fontSize: 12,
    letterSpacing: "0",
    fontFamily: a.fontFamily.body,
    fontStyle: "normal",
    fontWeight: a.fontWeight.robotoMedium,
    lineHeight: "16px"
  },
  overline: {
    fontSize: 10,
    letterSpacing: "1.5px",
    textTransform: "uppercase",
    fontFamily: a.fontFamily.body,
    fontWeight: "bold",
    fontStyle: "normal",
    lineHeight: "16px"
  },
  subtitle1: {
    fontSize: 16,
    letterSpacing: "0.15px",
    fontFamily: a.fontFamily.base,
    fontWeight: a.fontWeight.halisBook,
    fontStyle: "normal",
    lineHeight: "16px"
  },
  subtitle2: {
    fontSize: 14,
    letterSpacing: "0.1px",
    fontFamily: a.fontFamily.base,
    fontWeight: a.fontWeight.halisBook,
    fontStyle: "normal",
    lineHeight: "14px"
  },
  button: {
    fontSize: 16,
    letterSpacing: "1.2px",
    fontFamily: a.fontFamily.base,
    textTransform: "none",
    fontStyle: "normal",
    fontWeight: a.fontWeight.halisBook,
    lineHeight: "16px"
  }
}, { color: $ } = a, Ve = te({
  typography: Ke,
  palette: {
    primary: {
      main: $.blue,
      light: $.blue,
      dark: $.blueDark,
      contrastText: $.white
    },
    secondary: {
      main: $.blue,
      light: $.blue,
      dark: $.blueDark,
      contrastText: $.white
    },
    action: {
      hover: $.blueExtraLight,
      selected: $.blueExtraLight
    },
    error: {
      main: "#d85446"
    }
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 320,
      // mobile
      md: 561,
      // tablet
      lg: 1021,
      // desktop
      xl: 1600
    }
  },
  components: {
    // Customization
    /*
      Body font properties updated to v4 to prevent UI bugs.
      Related documentation.
      https://mui.com/guides/migration-v4/#cssbaseline
    */
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          fontSize: "0.875rem",
          lineHeight: "1.43",
          letterSpacing: "0.01071em"
        }
      }
    },
    MuiChip: {
      styleOverrides: {
        root: {
          backgroundColor: "linear-gradient(0deg, rgba(2, 136, 209, 0.15), rgba(2, 136, 209, 0.15)), var(--color-white)"
        },
        icon: {
          marginRight: 4
        },
        deleteIcon: {
          marginLeft: 4
        },
        colorPrimary: {
          backgroundColor: $.blueExtraLight,
          color: $.font,
          "& > svg": {
            color: $.font
          }
        },
        deleteIconColorPrimary: {
          "&:hover": {
            color: $.font
          }
        },
        deletableColorPrimary: {
          "&:focus": {
            backgroundColor: $.blueDark
          }
        }
      }
    },
    // new overrides to counter breaking changes in mui v4
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          margin: "4px 0",
          color: $.grayDark,
          "&.Mui-disabled": { color: $.grayDark },
          "&.Mui-error": { color: "#d85446" }
        }
      }
    },
    MuiTextField: {
      defaultProps: {
        variant: "standard"
      },
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-root": {
            borderRadius: a.schoolinks.containerBorderRadius,
            "&.Mui-disabled": {
              backgroundColor: $.grayBg,
              "& fieldset": { borderColor: "#eee" }
            },
            "& fieldset": {
              borderColor: $.grayLight
            },
            "&:not(.Mui-disabled, .Mui-error):hover fieldset": {
              borderColor: $.blue
            },
            "&.Mui-error fieldset": {
              borderColor: $.red,
              borderWidth: "2px"
            },
            "& input::placeholder": {
              opacity: 1,
              color: $.gray
            }
          }
        }
      }
    },
    MuiInputBase: {
      styleOverrides: {
        input: {
          "&.Mui-disabled": {
            "-webkit-text-fill-color": $.grayDark
          }
        }
      }
    },
    MuiTab: {
      styleOverrides: {
        root: {
          padding: "6px 12px"
        }
      }
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          paddingTop: 11,
          paddingBottom: 11
        }
      }
    },
    MuiAutocomplete: {
      styleOverrides: {
        popper: {
          zIndex: 1400
          // has to be bigger than the MuiModal zIndex
        },
        option: {
          "&.Mui-focused": {
            backgroundColor: `${$.blueDark} !important`
          }
        }
      }
    },
    // existing overrides
    MuiModal: {
      styleOverrides: {
        root: {
          // lowered from 1350 to 1300 so we can see date pickers in modals
          zIndex: 1300
        }
      }
    },
    MuiDialog: {
      defaultProps: {
        maxWidth: !1
      }
    },
    MuiDrawer: {
      styleOverrides: {
        root: {
          zIndex: 1300
        }
      }
    },
    MuiInput: {
      styleOverrides: {
        underline: {
          "&:before": {
            // underline color when textfield is inactive
            borderBottom: "2px solid #d8d8d8"
          },
          "&:after": {
            // underline color when textfield is active
            borderBottom: `2px solid ${$.blue}`
          },
          "&:hover:not($disabled):not($focused):not($error):before": {
            // underline color when hovered
            borderBottom: `2px solid ${$.blue}`
          }
        }
      }
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          "&:hover:not($disabled):not($focused):not($error) $notchedOutline": {
            // outline color when hovered
            borderColor: $.blue
          },
          "&$error $notchedOutline": {
            borderColor: $.red
          }
        },
        inputAdornedStart: {
          paddingLeft: 0
        }
      }
    },
    MuiFormLabel: {
      styleOverrides: {
        root: {
          "&$focused": {
            color: `${$.grayDark} !important`
          },
          "&$error": {
            color: $.red
          }
        }
      }
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          overflow: "inherit !important",
          "&.Mui-focused": {
            color: `${$.grayDark} !important`
          },
          "&.Mui-error": {
            color: `${$.grayDark} !important`
          }
        }
      }
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          "&$selected": {
            backgroundColor: "rgba(2,136,209,0.05)"
          },
          "&$hover:hover": {
            backgroundColor: "rgba(2,136,209,0.05)"
          }
        }
      }
    },
    MuiTablePagination: {
      defaultProps: {
        getItemAriaLabel: (t) => t === "next" ? "Next Page" : t === "previous" ? "Previous Page" : ""
      },
      styleOverrides: {
        selectLabel: {
          margin: 0
        },
        displayedRows: {
          margin: 0
        }
      }
    },
    MuiStepIcon: {
      styleOverrides: {
        root: {
          color: "#bbb !important",
          "&$active": {
            color: `${$.blue} !important`
          },
          "&$completed": {
            color: `${$.blue} !important`
          }
        },
        active: {},
        completed: {}
      }
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          fontSize: 12
        }
      }
    },
    MuiSvgIcon: {
      styleOverrides: {
        root: {
          fill: void 0
        }
      }
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          "& > .textLink, & > .textLinkButton": {
            textDecoration: "underline"
          }
        }
      }
    },
    MuiButtonBase: {
      defaultProps: {
        disableRipple: !0
      }
    },
    MuiYearPicker: {
      styleOverrides: {
        root: {
          "& .PrivatePickersYear-yearButton": {
            fontFamily: "Roboto, sans-serif",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          }
        }
      }
    },
    PrivatePickersYear: {
      styleOverrides: {
        yearButton: {
          fontFamily: "Roboto, sans-serif",
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }
      }
    }
  }
}), Pe = "_badgeContainer_6t1ke_3", to = "_label_6t1ke_9", eo = "_large_6t1ke_18", oo = "_badge_6t1ke_3", no = "_number_6t1ke_29", ro = "_font_6t1ke_42", ao = "_outlined_6t1ke_46", io = "_text_6t1ke_51", lo = "_orange_6t1ke_56", so = "_red_6t1ke_70", co = "_blue_6t1ke_84", fo = "_green_6t1ke_98", uo = "_yellow_6t1ke_112", mo = "_purple_6t1ke_126", ho = "_gray_6t1ke_140", go = "_blueSteel_6t1ke_154", bo = "_disabled_6t1ke_168", po = "_transparent_6t1ke_182", yo = "_hasWhiteBorder_6t1ke_186", J = {
  badgeContainer: Pe,
  label: to,
  large: eo,
  badge: oo,
  number: no,
  font: ro,
  outlined: ao,
  text: io,
  orange: lo,
  red: so,
  blue: co,
  green: fo,
  yellow: uo,
  purple: mo,
  gray: ho,
  blueSteel: go,
  disabled: bo,
  transparent: po,
  hasWhiteBorder: yo
}, qt = ({
  label: t,
  style: o,
  classes: r,
  number: n = 0,
  color: f = "gray",
  size: i = "medium",
  variant: d = "filled",
  disableEmpty: u = !0,
  hasWhiteBorder: p = !1,
  badgeClassName: v
}) => {
  const y = i === "large", x = d === "filled", C = d === "outlined", k = d === "text";
  return /* @__PURE__ */ W("div", { style: o, className: L(J.badgeContainer, r == null ? void 0 : r.root), children: [
    /* @__PURE__ */ e(
      "div",
      {
        "data-testid": "badgeNumberContainer",
        className: L(
          J.badge,
          J[Ie(f)],
          {
            [J.transparent]: !x,
            [J.disabled]: f === "disabled" || u && !n,
            [J.filled]: x,
            [J.outlined]: C,
            [J.text]: k,
            [J.whiteBorder]: p && x
          },
          v
        ),
        children: /* @__PURE__ */ e(
          "div",
          {
            "data-testid": "badgeNumber",
            className: L(J.number, { [J.large]: y }),
            children: n
          }
        )
      }
    ),
    t ? /* @__PURE__ */ e(
      "div",
      {
        "data-testid": "badgeLabel",
        className: L(J.label, { [J.large]: y }),
        children: t
      }
    ) : null
  ] });
}, _o = "_button_9lx1o_1", xo = "_withIconLeft_9lx1o_19", wo = "_withLabel_9lx1o_19", vo = "_withIconRight_9lx1o_20", So = "_disabled_9lx1o_24", ko = "_loading_9lx1o_29", Mo = "_small_9lx1o_33", $o = "_withWhiteBackground_9lx1o_44", Co = "_compactButton_9lx1o_50", Do = "_compactSmall_9lx1o_65", Lo = "_compactSelect_9lx1o_69", Wo = "_compactCircular_9lx1o_75", To = "_text_9lx1o_86", Bo = "_blue_9lx1o_91", Fo = "_filled_9lx1o_92", Oo = "_outlined_9lx1o_107", zo = "_compactLabel_9lx1o_151", No = "_badge_9lx1o_155", Ro = "_gray_9lx1o_160", Ho = "_red_9lx1o_229", Ao = "_badgeContainer_9lx1o_302", Eo = "_shadowButton_9lx1o_310", Io = "_rightIcon_9lx1o_461", jo = "_large_9lx1o_465", Xo = "_icon_9lx1o_465", Yo = "_noLabel_9lx1o_466", Uo = "_medium_9lx1o_471", Go = "_noLabelContainer_9lx1o_488", qo = "_label_9lx1o_492", Zo = "_popoverRoot_9lx1o_512", Jo = "_popoverPaper_9lx1o_516", Qo = "_arrow_9lx1o_522", Ko = "_arrowTop_9lx1o_523", Vo = "_arrowBottom_9lx1o_524", m = {
  button: _o,
  withIconLeft: xo,
  withLabel: wo,
  withIconRight: vo,
  disabled: So,
  loading: ko,
  small: Mo,
  withWhiteBackground: $o,
  compactButton: Co,
  compactSmall: Do,
  compactSelect: Lo,
  compactCircular: Wo,
  text: To,
  blue: Bo,
  filled: Fo,
  outlined: Oo,
  compactLabel: zo,
  badge: No,
  gray: Ro,
  red: Ho,
  badgeContainer: Ao,
  shadowButton: Eo,
  rightIcon: Io,
  large: jo,
  icon: Xo,
  noLabel: Yo,
  medium: Uo,
  noLabelContainer: Go,
  label: qo,
  popoverRoot: Zo,
  popoverPaper: Jo,
  arrow: Qo,
  arrowTop: Ko,
  arrowBottom: Vo
}, Po = ({
  badgeCount: t,
  color: o,
  component: r,
  handleClick: n,
  hasIconLeft: f,
  hasIconRight: i,
  hasNoWrap: d,
  hasWhiteBackground: u,
  iconToRender: p,
  isFilled: v,
  isLoading: y,
  isOutlined: x,
  isSmall: C,
  isText: k,
  label: M,
  showBadge: g,
  tooltipProps: O,
  ...D
}) => /* @__PURE__ */ e(gt, { title: (O == null ? void 0 : O.title) ?? "", ...O, children: /* @__PURE__ */ W(
  r,
  {
    "data-testid": "base-button",
    ...D,
    className: L(D.className, m.button, {
      [m.small]: C,
      [m.disabled]: D.disabled,
      [m.text]: k,
      [m.loading]: y,
      [m.blue]: o === "blue",
      [m.red]: o === "red",
      [m.gray]: o === "gray",
      [m.withIconLeft]: f,
      [m.withIconRight]: i,
      [m.withLabel]: M,
      [m.filled]: v,
      [m.outlined]: x,
      [m.withWhiteBackground]: u
    }),
    style: {
      whiteSpace: d ? "nowrap" : void 0,
      ...D.style
    },
    onClick: n,
    children: [
      (f || y) && p,
      M,
      i && p,
      g && /* @__PURE__ */ e(
        qt,
        {
          number: t ?? 0,
          color: o,
          hasWhiteBorder: !0,
          classes: { root: m.badgeContainer },
          badgeClassName: m.badge
        }
      )
    ]
  }
) }), tn = ({
  badgeCount: t,
  color: o,
  component: r,
  handleClick: n,
  hasNoWrap: f,
  hasWhiteBackground: i,
  iconToRender: d,
  innerLabel: u,
  isCompactSelect: p,
  isFilled: v,
  isLoading: y,
  isOutlined: x,
  isSmall: C,
  isText: k,
  label: M,
  showBadge: g,
  textVariant: O,
  tooltipProps: D,
  ...A
}) => /* @__PURE__ */ e(gt, { title: (D == null ? void 0 : D.title) ?? "", ...D, children: /* @__PURE__ */ W(I, { flexDirection: "column", alignItems: "center", width: "fit-content", children: [
  /* @__PURE__ */ W(
    r,
    {
      "data-testid": "compact-button",
      ...A,
      className: L(m.compactButton, A.className, {
        [m.compactCircular]: !C,
        [m.compactSmall]: C,
        [m.compactSelect]: p,
        [m.compactSmallSelect]: C && p,
        [m.disabled]: A.disabled,
        [m.loading]: y,
        [m.blue]: o === "blue",
        [m.red]: o === "red",
        [m.gray]: o === "gray",
        [m.text]: k,
        [m.filled]: v,
        [m.outlined]: x,
        [m.withWhiteBackground]: i
      }),
      style: {
        whiteSpace: f ? "nowrap" : void 0,
        ...A.style
      },
      onClick: n,
      children: [
        u && /* @__PURE__ */ e(st, { variant: O, children: u }),
        d,
        p && /* @__PURE__ */ e(F, { icon: re }),
        g && /* @__PURE__ */ e(
          qt,
          {
            number: t ?? 0,
            color: o,
            hasWhiteBorder: !0,
            classes: { root: m.badge }
          }
        )
      ]
    }
  ),
  M && /* @__PURE__ */ e(
    st,
    {
      className: m.compactLabel,
      color: `${o}XtraDark`,
      variant: "label",
      mt: 0.5,
      children: M.toUpperCase()
    }
  )
] }) }), en = ({ title: t }) => typeof t == "string" ? /* @__PURE__ */ e(vt, { children: t }) : t, on = "_tooltip_1hh81_3", nn = {
  tooltip: on
}, gt = ({
  title: t = "",
  arrow: o = !0,
  tooltipClass: r = "",
  children: n,
  ...f
}) => {
  const { classes: i = {} } = f;
  return /* @__PURE__ */ e(
    ae,
    {
      ...f,
      classes: {
        ...i,
        tooltip: L(nn.tooltip, r)
      },
      title: t && /* @__PURE__ */ e(en, { title: t }),
      enterTouchDelay: 0,
      arrow: o,
      children: n
    }
  );
}, rn = {
  blue: m.blue,
  gray: m.gray,
  red: m.red,
  green: m.green
}, an = {
  outlined: m.outlined,
  filled: m.filled,
  text: m.text
}, ln = {
  large: m.large,
  medium: m.medium,
  small: m.small
}, sn = ({
  classes: t,
  color: o = "blue",
  component: r,
  handleClick: n,
  hasIconRight: f,
  iconToRender: i,
  isLoading: d,
  label: u,
  size: p = "large",
  tooltipProps: v,
  variant: y = "outlined",
  ...x
}) => /* @__PURE__ */ e(gt, { title: (v == null ? void 0 : v.title) ?? "", ...v, children: /* @__PURE__ */ W(
  r,
  {
    "data-testid": "shadow-button",
    ...x,
    className: L(
      m.shadowButton,
      rn[o],
      an[y] || m.outlined,
      ln[p],
      {
        [m.rightIcon]: f,
        [m.disabled]: x.disabled,
        [m.noLabelContainer]: !u,
        [m.loading]: d
      },
      x.className
    ),
    onClick: n,
    children: [
      i ? /* @__PURE__ */ e("span", { className: L(m.icon, { [m.noLabel]: !u }, t == null ? void 0 : t.icon), children: i }) : null,
      u ? /* @__PURE__ */ e("span", { className: L(m.label, t == null ? void 0 : t.label), children: u }) : null
    ]
  }
) }), wt = (t) => /^http(s)?:\/\//.test(t) || /mailto:([^?]*)/.test(t), Bt = ({
  badgeCount: t,
  children: o,
  classes: r,
  color: n = "blue",
  compactVariant: f,
  confirmationPopoverProps: i,
  hasIconLeft: d,
  hasIconRight: u,
  hasNoWrap: p,
  hasWhiteBackground: v,
  href: y,
  icon: x,
  innerLabel: C,
  isLoading: k,
  label: M,
  newTab: g,
  size: O = "medium",
  textVariant: D,
  tooltipProps: A,
  variant: E,
  withShadow: Z,
  ...z
}) => {
  const [U, Y] = ht(null), at = ({
    currentTarget: j
  }) => Y(j), et = (j) => {
    j && j.stopPropagation(), Y(null);
  }, B = !!U, S = B ? "popover" : void 0, it = f === "select", dt = f === "default", b = O === "small", s = E === "outlined", l = E === "filled", h = E === "text" || !s && !l, w = !!t && (s || dt), {
    confirmationOpenColor: _,
    confirmationButtonColor: T,
    confirmationText: N,
    confirmationPopover: R,
    confirmationButtonText: X,
    confirmationPopoverCancelButtonText: q,
    arrowDirection: P,
    arrow: lt,
    popoverPaperClassName: ft
  } = i ?? {}, ot = {
    arrow: /* @__PURE__ */ e(
      F,
      {
        rotation: d ? 180 : void 0,
        icon: he
      }
    ),
    chevron: /* @__PURE__ */ e(
      F,
      {
        icon: u || d ? be : ge,
        rotation: d ? 180 : void 0
      }
    ),
    edit: /* @__PURE__ */ e(F, { "data-testid": "edit-icon", icon: fe }),
    plus: /* @__PURE__ */ e(F, { icon: ue }),
    trash: /* @__PURE__ */ e(F, { icon: me }),
    lock: /* @__PURE__ */ e(F, { icon: de }),
    download: /* @__PURE__ */ e(F, { icon: se })
  }, tt = k ? /* @__PURE__ */ e(F, { "data-testid": "loader-icon", icon: ce, spin: !0 }) : Object.keys(ot).includes(x) ? ot[x] : x, ct = (j) => {
    var pt;
    if (!(k || z.disabled)) {
      if (N || R) {
        j.stopPropagation(), at(j);
        return;
      }
      (pt = z.onClick) == null || pt.call(z, j);
    }
  }, Nt = (() => {
    if (!y || z.disabled)
      return {
        component: "button",
        to: ""
      };
    const j = g || wt(y) ? { target: "_blank", rel: "noopener noreferrer" } : {};
    return wt(y) ? { component: "a", to: "", href: y, ...j } : { component: Ct, to: y, ...j };
  })();
  return /* @__PURE__ */ W(vt, { children: [
    (() => {
      if (Z)
        return /* @__PURE__ */ e(
          sn,
          {
            classes: r,
            color: _ ?? n,
            handleClick: ct,
            hasIconLeft: d,
            hasIconRight: u,
            iconToRender: tt,
            isLoading: k,
            label: M,
            size: O,
            tooltipProps: A,
            variant: E,
            ...z,
            ...Nt
          }
        );
      const j = {
        badgeCount: t,
        color: _ ?? n,
        handleClick: ct,
        hasNoWrap: p,
        hasWhiteBackground: v,
        iconToRender: tt,
        isLoading: k,
        isSmall: b,
        label: M,
        showBadge: w,
        tooltipProps: A,
        isText: h,
        isFilled: l,
        isOutlined: s,
        ...z,
        ...Nt
      };
      return it || dt ? /* @__PURE__ */ e(
        tn,
        {
          isCompactSelect: it,
          innerLabel: C,
          textVariant: D,
          ...j
        }
      ) : /* @__PURE__ */ e(
        Po,
        {
          hasIconLeft: d,
          hasIconRight: u,
          ...j
        }
      );
    })(),
    /* @__PURE__ */ e(
      Ut,
      {
        id: S,
        open: B,
        anchorEl: U,
        onClose: et,
        anchorOrigin: {
          vertical: P === "top" ? "bottom" : "top",
          horizontal: "center"
        },
        transformOrigin: {
          vertical: P === "top" ? "top" : "bottom",
          horizontal: "center"
        },
        classes: {
          root: m.popoverRoot,
          paper: L(m.popoverPaper, ft, {
            [m.arrow]: lt,
            [m.arrowTop]: P === "top",
            [m.arrowBottom]: P === "bottom"
          })
        },
        ...i,
        children: R ? R({
          closePopover: () => Y(null)
        }) : /* @__PURE__ */ W("div", { children: [
          N && /* @__PURE__ */ e(st, { variant: "bodySm400", mb: 1.5, children: N }),
          /* @__PURE__ */ W(
            I,
            {
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%",
              children: [
                /* @__PURE__ */ e(
                  Bt,
                  {
                    label: q ?? "Cancel",
                    size: "small",
                    color: "gray",
                    variant: "text",
                    onClick: (j) => {
                      j.stopPropagation(), Y(null);
                    }
                  }
                ),
                /* @__PURE__ */ e(
                  Bt,
                  {
                    label: X ?? "Delete",
                    size: "small",
                    variant: "outlined",
                    color: T ?? "red",
                    onClick: (j) => {
                      var pt;
                      j.stopPropagation(), (pt = z.onClick) == null || pt.call(z, j), Y(null);
                    }
                  }
                )
              ]
            }
          )
        ] })
      }
    )
  ] });
};
function cn(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var $t = { exports: {} }, dn = $t.exports, At;
function fn() {
  return At || (At = 1, function(t, o) {
    (function(r, n) {
      t.exports = n();
    })(dn, function() {
      var r = 1e3, n = 6e4, f = 36e5, i = "millisecond", d = "second", u = "minute", p = "hour", v = "day", y = "week", x = "month", C = "quarter", k = "year", M = "date", g = "Invalid Date", O = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, D = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, A = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(b) {
        var s = ["th", "st", "nd", "rd"], l = b % 100;
        return "[" + b + (s[(l - 20) % 10] || s[l] || s[0]) + "]";
      } }, E = function(b, s, l) {
        var h = String(b);
        return !h || h.length >= s ? b : "" + Array(s + 1 - h.length).join(l) + b;
      }, Z = { s: E, z: function(b) {
        var s = -b.utcOffset(), l = Math.abs(s), h = Math.floor(l / 60), c = l % 60;
        return (s <= 0 ? "+" : "-") + E(h, 2, "0") + ":" + E(c, 2, "0");
      }, m: function b(s, l) {
        if (s.date() < l.date()) return -b(l, s);
        var h = 12 * (l.year() - s.year()) + (l.month() - s.month()), c = s.clone().add(h, x), w = l - c < 0, _ = s.clone().add(h + (w ? -1 : 1), x);
        return +(-(h + (l - c) / (w ? c - _ : _ - c)) || 0);
      }, a: function(b) {
        return b < 0 ? Math.ceil(b) || 0 : Math.floor(b);
      }, p: function(b) {
        return { M: x, y: k, w: y, d: v, D: M, h: p, m: u, s: d, ms: i, Q: C }[b] || String(b || "").toLowerCase().replace(/s$/, "");
      }, u: function(b) {
        return b === void 0;
      } }, z = "en", U = {};
      U[z] = A;
      var Y = "$isDayjsObject", at = function(b) {
        return b instanceof it || !(!b || !b[Y]);
      }, et = function b(s, l, h) {
        var c;
        if (!s) return z;
        if (typeof s == "string") {
          var w = s.toLowerCase();
          U[w] && (c = w), l && (U[w] = l, c = w);
          var _ = s.split("-");
          if (!c && _.length > 1) return b(_[0]);
        } else {
          var T = s.name;
          U[T] = s, c = T;
        }
        return !h && c && (z = c), c || !h && z;
      }, B = function(b, s) {
        if (at(b)) return b.clone();
        var l = typeof s == "object" ? s : {};
        return l.date = b, l.args = arguments, new it(l);
      }, S = Z;
      S.l = et, S.i = at, S.w = function(b, s) {
        return B(b, { locale: s.$L, utc: s.$u, x: s.$x, $offset: s.$offset });
      };
      var it = function() {
        function b(l) {
          this.$L = et(l.locale, null, !0), this.parse(l), this.$x = this.$x || l.x || {}, this[Y] = !0;
        }
        var s = b.prototype;
        return s.parse = function(l) {
          this.$d = function(h) {
            var c = h.date, w = h.utc;
            if (c === null) return /* @__PURE__ */ new Date(NaN);
            if (S.u(c)) return /* @__PURE__ */ new Date();
            if (c instanceof Date) return new Date(c);
            if (typeof c == "string" && !/Z$/i.test(c)) {
              var _ = c.match(O);
              if (_) {
                var T = _[2] - 1 || 0, N = (_[7] || "0").substring(0, 3);
                return w ? new Date(Date.UTC(_[1], T, _[3] || 1, _[4] || 0, _[5] || 0, _[6] || 0, N)) : new Date(_[1], T, _[3] || 1, _[4] || 0, _[5] || 0, _[6] || 0, N);
              }
            }
            return new Date(c);
          }(l), this.init();
        }, s.init = function() {
          var l = this.$d;
          this.$y = l.getFullYear(), this.$M = l.getMonth(), this.$D = l.getDate(), this.$W = l.getDay(), this.$H = l.getHours(), this.$m = l.getMinutes(), this.$s = l.getSeconds(), this.$ms = l.getMilliseconds();
        }, s.$utils = function() {
          return S;
        }, s.isValid = function() {
          return this.$d.toString() !== g;
        }, s.isSame = function(l, h) {
          var c = B(l);
          return this.startOf(h) <= c && c <= this.endOf(h);
        }, s.isAfter = function(l, h) {
          return B(l) < this.startOf(h);
        }, s.isBefore = function(l, h) {
          return this.endOf(h) < B(l);
        }, s.$g = function(l, h, c) {
          return S.u(l) ? this[h] : this.set(c, l);
        }, s.unix = function() {
          return Math.floor(this.valueOf() / 1e3);
        }, s.valueOf = function() {
          return this.$d.getTime();
        }, s.startOf = function(l, h) {
          var c = this, w = !!S.u(h) || h, _ = S.p(l), T = function(ot, G) {
            var tt = S.w(c.$u ? Date.UTC(c.$y, G, ot) : new Date(c.$y, G, ot), c);
            return w ? tt : tt.endOf(v);
          }, N = function(ot, G) {
            return S.w(c.toDate()[ot].apply(c.toDate("s"), (w ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(G)), c);
          }, R = this.$W, X = this.$M, q = this.$D, P = "set" + (this.$u ? "UTC" : "");
          switch (_) {
            case k:
              return w ? T(1, 0) : T(31, 11);
            case x:
              return w ? T(1, X) : T(0, X + 1);
            case y:
              var lt = this.$locale().weekStart || 0, ft = (R < lt ? R + 7 : R) - lt;
              return T(w ? q - ft : q + (6 - ft), X);
            case v:
            case M:
              return N(P + "Hours", 0);
            case p:
              return N(P + "Minutes", 1);
            case u:
              return N(P + "Seconds", 2);
            case d:
              return N(P + "Milliseconds", 3);
            default:
              return this.clone();
          }
        }, s.endOf = function(l) {
          return this.startOf(l, !1);
        }, s.$set = function(l, h) {
          var c, w = S.p(l), _ = "set" + (this.$u ? "UTC" : ""), T = (c = {}, c[v] = _ + "Date", c[M] = _ + "Date", c[x] = _ + "Month", c[k] = _ + "FullYear", c[p] = _ + "Hours", c[u] = _ + "Minutes", c[d] = _ + "Seconds", c[i] = _ + "Milliseconds", c)[w], N = w === v ? this.$D + (h - this.$W) : h;
          if (w === x || w === k) {
            var R = this.clone().set(M, 1);
            R.$d[T](N), R.init(), this.$d = R.set(M, Math.min(this.$D, R.daysInMonth())).$d;
          } else T && this.$d[T](N);
          return this.init(), this;
        }, s.set = function(l, h) {
          return this.clone().$set(l, h);
        }, s.get = function(l) {
          return this[S.p(l)]();
        }, s.add = function(l, h) {
          var c, w = this;
          l = Number(l);
          var _ = S.p(h), T = function(X) {
            var q = B(w);
            return S.w(q.date(q.date() + Math.round(X * l)), w);
          };
          if (_ === x) return this.set(x, this.$M + l);
          if (_ === k) return this.set(k, this.$y + l);
          if (_ === v) return T(1);
          if (_ === y) return T(7);
          var N = (c = {}, c[u] = n, c[p] = f, c[d] = r, c)[_] || 1, R = this.$d.getTime() + l * N;
          return S.w(R, this);
        }, s.subtract = function(l, h) {
          return this.add(-1 * l, h);
        }, s.format = function(l) {
          var h = this, c = this.$locale();
          if (!this.isValid()) return c.invalidDate || g;
          var w = l || "YYYY-MM-DDTHH:mm:ssZ", _ = S.z(this), T = this.$H, N = this.$m, R = this.$M, X = c.weekdays, q = c.months, P = c.meridiem, lt = function(G, tt, ct, bt) {
            return G && (G[tt] || G(h, w)) || ct[tt].slice(0, bt);
          }, ft = function(G) {
            return S.s(T % 12 || 12, G, "0");
          }, ot = P || function(G, tt, ct) {
            var bt = G < 12 ? "AM" : "PM";
            return ct ? bt.toLowerCase() : bt;
          };
          return w.replace(D, function(G, tt) {
            return tt || function(ct) {
              switch (ct) {
                case "YY":
                  return String(h.$y).slice(-2);
                case "YYYY":
                  return S.s(h.$y, 4, "0");
                case "M":
                  return R + 1;
                case "MM":
                  return S.s(R + 1, 2, "0");
                case "MMM":
                  return lt(c.monthsShort, R, q, 3);
                case "MMMM":
                  return lt(q, R);
                case "D":
                  return h.$D;
                case "DD":
                  return S.s(h.$D, 2, "0");
                case "d":
                  return String(h.$W);
                case "dd":
                  return lt(c.weekdaysMin, h.$W, X, 2);
                case "ddd":
                  return lt(c.weekdaysShort, h.$W, X, 3);
                case "dddd":
                  return X[h.$W];
                case "H":
                  return String(T);
                case "HH":
                  return S.s(T, 2, "0");
                case "h":
                  return ft(1);
                case "hh":
                  return ft(2);
                case "a":
                  return ot(T, N, !0);
                case "A":
                  return ot(T, N, !1);
                case "m":
                  return String(N);
                case "mm":
                  return S.s(N, 2, "0");
                case "s":
                  return String(h.$s);
                case "ss":
                  return S.s(h.$s, 2, "0");
                case "SSS":
                  return S.s(h.$ms, 3, "0");
                case "Z":
                  return _;
              }
              return null;
            }(G) || _.replace(":", "");
          });
        }, s.utcOffset = function() {
          return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, s.diff = function(l, h, c) {
          var w, _ = this, T = S.p(h), N = B(l), R = (N.utcOffset() - this.utcOffset()) * n, X = this - N, q = function() {
            return S.m(_, N);
          };
          switch (T) {
            case k:
              w = q() / 12;
              break;
            case x:
              w = q();
              break;
            case C:
              w = q() / 3;
              break;
            case y:
              w = (X - R) / 6048e5;
              break;
            case v:
              w = (X - R) / 864e5;
              break;
            case p:
              w = X / f;
              break;
            case u:
              w = X / n;
              break;
            case d:
              w = X / r;
              break;
            default:
              w = X;
          }
          return c ? w : S.a(w);
        }, s.daysInMonth = function() {
          return this.endOf(x).$D;
        }, s.$locale = function() {
          return U[this.$L];
        }, s.locale = function(l, h) {
          if (!l) return this.$L;
          var c = this.clone(), w = et(l, h, !0);
          return w && (c.$L = w), c;
        }, s.clone = function() {
          return S.w(this.$d, this);
        }, s.toDate = function() {
          return new Date(this.valueOf());
        }, s.toJSON = function() {
          return this.isValid() ? this.toISOString() : null;
        }, s.toISOString = function() {
          return this.$d.toISOString();
        }, s.toString = function() {
          return this.$d.toUTCString();
        }, b;
      }(), dt = it.prototype;
      return B.prototype = dt, [["$ms", i], ["$s", d], ["$m", u], ["$H", p], ["$W", v], ["$M", x], ["$y", k], ["$D", M]].forEach(function(b) {
        dt[b[1]] = function(s) {
          return this.$g(s, b[0], b[1]);
        };
      }), B.extend = function(b, s) {
        return b.$i || (b(s, it, B), b.$i = !0), B;
      }, B.locale = et, B.isDayjs = at, B.unix = function(b) {
        return B(1e3 * b);
      }, B.en = U[z], B.Ls = U, B.p = {}, B;
    });
  }($t)), $t.exports;
}
var un = fn();
const ut = /* @__PURE__ */ cn(un), mn = ({ event: t, children: o }) => /* @__PURE__ */ e(
  "div",
  {
    className: L("rbc-event-wrapper", t.color ?? "", {
      "rbc-event-filled": t.variant === "filled"
    }),
    children: o
  }
);
[...Intl.supportedValuesOf("timeZone")];
var Ft = /* @__PURE__ */ ((t) => (t.Back = "back", t.Forward = "forward", t))(Ft || {});
const hn = ({
  disabled: t,
  viewMode: o,
  viewLabel: r,
  onMove: n,
  onMoveToday: f,
  onChangeView: i
}) => /* @__PURE__ */ W(
  I,
  {
    className: "rbc-toolbar",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 0.5,
    children: [
      /* @__PURE__ */ e(I, { className: "rbc-left-toolbar", children: /* @__PURE__ */ e(
        "button",
        {
          className: "rbc-btn-standalone rbc-btn-today",
          type: "button",
          onClick: f,
          disabled: t,
          children: "Today"
        }
      ) }),
      /* @__PURE__ */ W(I, { gap: 0.5, alignItems: "center", children: [
        /* @__PURE__ */ e(
          "button",
          {
            type: "button",
            className: "rbc-btn-standalone",
            "aria-label": "move back",
            disabled: t,
            onClick: () => {
              n(Ft.Back);
            },
            children: /* @__PURE__ */ e(F, { icon: Rt })
          }
        ),
        /* @__PURE__ */ e("h2", { className: "rbc-toolbar-label", children: r }),
        /* @__PURE__ */ e(
          "button",
          {
            type: "button",
            className: "rbc-btn-standalone",
            "aria-label": "move forward",
            disabled: t,
            onClick: () => {
              n(Ft.Forward);
            },
            children: /* @__PURE__ */ e(F, { icon: Rt, rotation: 180 })
          }
        )
      ] }),
      /* @__PURE__ */ e("div", { className: "rbc-btn-group rbc-right-toolbar", children: ["Month", "Week", "Day"].map((u) => /* @__PURE__ */ e(
        "button",
        {
          type: "button",
          disabled: t,
          onClick: () => {
            i(u.toLowerCase());
          },
          className: L({
            "rbc-active": o === u.toLowerCase()
          }),
          children: u
        },
        u
      )) })
    ]
  }
), gn = {
  mobile: `(max-width: ${xt.mobileMax})`,
  tablet: `(min-width: ${xt.tabletMin}) and (max-width: ${xt.tabletMax})`,
  desktop: `(min-width: ${xt.desktopMin})`
}, bn = (t = gn) => {
  const o = Lt(t.mobile), r = Lt(t.tablet), n = Lt(t.desktop);
  return { isMobile: o, isTablet: r, isDesktop: n };
}, I = mt.forwardRef(
  ({ children: t, className: o, ...r }, n) => /* @__PURE__ */ e(
    ie,
    {
      "data-testid": "flexContainer",
      ref: n,
      className: o,
      display: "flex",
      ...r,
      children: t
    }
  )
), Dt = (t, o) => t && t in a.color ? a.color[t] : o, F = ({
  className: t,
  color: o,
  onClick: r,
  fixedWidth: n = !1,
  inverse: f = !1,
  listItem: i = !1,
  spin: d = !1,
  swapOpacity: u = !1,
  "data-testid": p,
  ...v
}) => {
  const y = Dt(o);
  return /* @__PURE__ */ e(
    _e,
    {
      className: t,
      color: y,
      "data-testid": p,
      fixedWidth: n,
      inverse: f,
      listItem: i,
      spin: d,
      swapOpacity: u,
      ...v
    }
  );
}, Ot = ({
  event: t,
  align: o = "start",
  timezone: r,
  tooltipPlacement: n
}) => {
  const f = (t == null ? void 0 : t.variant) === "filled", i = t.icon ? t.icon : null, d = Intl.DateTimeFormat("en-US", {
    timeZone: r || Intl.DateTimeFormat().resolvedOptions().timeZone,
    hour: "numeric",
    minute: "2-digit",
    hour12: !0
  }).format(t == null ? void 0 : t.start), u = `${t.title}, ${d}`, p = /* @__PURE__ */ W("div", { className: "rbc-event-title", children: [
    t.title,
    ", ",
    d
  ] }), v = n ? /* @__PURE__ */ e(gt, { title: u, placement: n, children: p }) : p;
  return /* @__PURE__ */ W(I, { title: "", alignItems: o, gap: 0.5, "data-testid": t.title, children: [
    i ? /* @__PURE__ */ e(F, { icon: i, color: f ? "white" : t.color }) : null,
    /* @__PURE__ */ e("div", { className: "rbc-title-wrapper", children: v })
  ] });
}, pn = ({
  event: t,
  timezone: o,
  tooltipPlacement: r
}) => /* @__PURE__ */ e(
  Ot,
  {
    align: "center",
    event: t,
    timezone: o,
    tooltipPlacement: r
  }
), yn = ({
  initialDate: t,
  initialViewMode: o = "month",
  onRangeChange: r,
  onViewChange: n
}) => {
  const [f, i] = ht(t), [d, u] = ht(o), [p, v] = ht(o);
  o !== p && (v(o), u(o));
  const y = {
    day: "d",
    week: "w",
    month: "M"
  }, x = (g) => {
    u(g), C(f, y[g]), n == null || n(g);
  }, C = (g, O) => {
    const D = ut(g).startOf(O).toDate(), A = ut(g).endOf(O).toDate();
    r == null || r({ start: D, end: A });
  };
  return {
    currentDate: f,
    viewMode: d,
    onChangeView: x,
    onMove: (g) => {
      if (g === "back") {
        const D = ut(f).subtract(1, y[d]).toDate();
        i(D), C(D, y[d]);
        return;
      }
      const O = ut(f).add(1, y[d]).toDate();
      i(O), C(O, y[d]);
    },
    onMoveToday: () => {
      const g = ut().toDate();
      i(g), C(g, "d");
    }
  };
};
function _n(t, o) {
  const r = ut(o);
  switch (t) {
    case "week": {
      const n = r.clone().startOf("week"), f = r.clone().endOf("week");
      return `${n.format("MMMM DD")} - ${f.format(
        "DD, YYYY"
      )}`;
    }
    case "month":
      return r.format("MMMM, YYYY");
    case "day":
      return r.format("MMMM DD, YYYY");
    default:
      return "";
  }
}
const xn = pe(ut), ai = ({
  events: t,
  initialDate: o,
  initialViewMode: r = "month",
  height: n,
  selectable: f = !0,
  loading: i = !1,
  grow: d = !0,
  className: u,
  classes: p,
  onNavigate: v = () => {
  },
  onViewChange: y = () => {
  },
  onView: x = () => {
  },
  tooltipPlacement: C,
  timezone: k,
  onRangeChange: M,
  restricted: g = !1,
  ...O
}) => {
  const { isMobile: D } = bn(), { currentDate: A, viewMode: E, onChangeView: Z, onMove: z, onMoveToday: U } = yn({
    initialDate: o,
    initialViewMode: r,
    onRangeChange: M,
    onViewChange: y
  }), { containerClassName: Y = "", rootClassName: at = "" } = p ?? {}, et = _n(E, A), B = D ? void 0 : C;
  return /* @__PURE__ */ W(
    "div",
    {
      className: L("rbc-calendar-container", Y, {
        grow: d,
        loading: i,
        restricted: g
      }),
      children: [
        /* @__PURE__ */ e(
          hn,
          {
            disabled: !!i,
            viewLabel: et,
            viewMode: E,
            onChangeView: Z,
            onMoveToday: U,
            onMove: z
          }
        ),
        /* @__PURE__ */ e(
          ye,
          {
            className: L(at, {
              "rbc-week-view": E === "week"
            }),
            localizer: xn,
            date: A,
            events: t,
            startAccessor: "start",
            view: E,
            onView: x,
            toolbar: !1,
            selectable: f,
            onNavigate: v,
            components: {
              day: {
                event: (S) => /* @__PURE__ */ e(
                  Ot,
                  {
                    ...S,
                    timezone: k,
                    tooltipPlacement: B
                  }
                )
              },
              week: {
                event: (S) => /* @__PURE__ */ e(
                  Ot,
                  {
                    ...S,
                    timezone: k,
                    tooltipPlacement: B
                  }
                )
              },
              month: {
                event: (S) => /* @__PURE__ */ e(
                  pn,
                  {
                    ...S,
                    timezone: k,
                    tooltipPlacement: B
                  }
                )
              },
              eventWrapper: mn
            },
            endAccessor: "end",
            views: ["month", "week", "day"],
            style: { height: n },
            ...O
          }
        )
      ]
    }
  );
};
var H = /* @__PURE__ */ ((t) => (t.h1 = "h1", t.h2 = "h2", t.h3 = "h3", t.h4 = "h4", t.h5 = "h5", t.h6 = "h6", t.lead400 = "lead400", t.lead500 = "lead500", t.lead700 = "lead700", t.titleMd500 = "titleMd500", t.titleMd700 = "titleMd700", t.titleSm500 = "titleSm500", t.titleSm700 = "titleSm700", t.bodyMd400 = "bodyMd400", t.bodyMd500 = "bodyMd500", t.bodyMd600 = "bodyMd600", t.bodyMd700 = "bodyMd700", t.bodySm400 = "bodySm400", t.bodySm500 = "bodySm500", t.bodySm600 = "bodySm600", t.bodySm700 = "bodySm700", t.meta400 = "meta400", t.meta700 = "meta700", t.label = "label", t.tiny = "tiny", t.mono = "mono", t.cursive = "cursive", t.stat1 = "stat1", t.stat2 = "stat2", t.stat3 = "stat3", t.stat4 = "stat4", t.stat5 = "stat5", t.stat6 = "stat6", t))(H || {});
const Et = {
  lead: H.lead400,
  leadBold: H.lead700,
  titleMd: H.titleMd500,
  titleMdBold: H.titleMd700,
  titleSm: H.titleSm500,
  titleSmBold: H.titleSm700,
  bodyMd: H.bodyMd400,
  bodyMdBold: H.bodyMd700,
  bodySm: H.bodySm400,
  bodySmBold: H.bodySm700,
  meta: H.meta400,
  metaBold: H.meta700,
  // Deprecated variants
  body1: H.bodyMd400,
  body2: H.bodySm400,
  subtitle1: H.titleMd500,
  subtitle2: H.titleSm500,
  caption: H.label,
  overline: H.tiny,
  button: H.bodyMd400
}, wn = a.color.font, vn = /^#([a-fA-F0-9]{6}|[a-fA-F0-9]{3})$/g, Sn = (t = "") => {
  const o = a.color[t];
  return Object.keys(a.color).includes(t) || vn.test(String(o)) ? o : (t && console.warn(`Wrong color name '${t}' provided, using fallback color.`), wn);
}, kn = (t) => typeof t == "string" && document.createElement(t) instanceof HTMLUnknownElement ? "p" : t, Mn = (t) => {
  const o = Object.keys(Et);
  return t in H ? t : o.includes(t) ? Et[t] : H.bodyMd500;
}, $n = "_textWrapper_1bmn2_3", Cn = "_italic_1bmn2_9", Dn = "_bold_1bmn2_13", Ln = "_rebrand_1bmn2_18", Wn = "_underlined_1bmn2_22", yt = {
  textWrapper: $n,
  italic: Cn,
  bold: Dn,
  rebrand: Ln,
  underlined: Wn
}, st = mt.forwardRef(
  ({
    className: t,
    color: o,
    component: r = "p",
    isBold: n,
    isItalic: f,
    isRebrand: i,
    isRebrandUnderlined: d,
    testId: u,
    variant: p = "bodyMd600",
    ...v
  }, y) => {
    const x = Mn(
      p
    );
    return /* @__PURE__ */ e(
      le,
      {
        ref: y,
        "data-testid": u,
        sx: { color: Sn(o) },
        className: L(t, yt[x], {
          [yt.italic]: f,
          [yt.bold]: n,
          [yt.rebrand]: i,
          [yt.underlined]: d
        }),
        variant: x,
        component: kn(r),
        ...v
      }
    );
  }
), Tn = "_root_bokhp_1", Bn = {
  root: Tn
}, It = {
  approved: {
    label: "REGISTERED",
    textColor: "greenContrastDark",
    backgroundColor: "greenExtraLight",
    icon: Se,
    iconColor: "greenXtraDark"
  },
  requested: {
    label: "REQUEST PENDING",
    textColor: "orangeContrastDark",
    backgroundColor: "orangeExtraLight",
    icon: ve,
    iconColor: "orangeXtraDark"
  },
  rejected: {
    label: "REQUEST DECLINED",
    textColor: "redContrastDark",
    backgroundColor: "redExtraLight",
    icon: we,
    iconColor: "redXtraDark"
  },
  removed: {
    label: "UNREGISTERED",
    textColor: "font",
    backgroundColor: "grayExtraLight",
    icon: xe,
    iconColor: "grayXtraDark"
  }
}, Fn = ({ variant: t, label: o, icon: r }) => {
  if (!(t in It))
    return null;
  const {
    backgroundColor: n,
    label: f,
    icon: i,
    textColor: d,
    iconColor: u
  } = It[t];
  return /* @__PURE__ */ W(
    I,
    {
      alignItems: "center",
      className: Bn.root,
      sx: {
        p: 1,
        backgroundColor: Dt(n)
      },
      "data-testid": "card-cap",
      children: [
        /* @__PURE__ */ e(F, { icon: r || i, color: u, size: "xs" }),
        /* @__PURE__ */ e(st, { ml: 0.5, variant: "tiny", color: d, children: o || f })
      ]
    }
  );
}, On = "_root_154wt_1", zn = "_shadow_154wt_45", Nn = "_rounded_154wt_49", Wt = {
  root: On,
  shadow: zn,
  rounded: Nn
}, Rn = [
  "a",
  "abbr",
  "address",
  "area",
  "article",
  "aside",
  "audio",
  "b",
  "base",
  "bdi",
  "bdo",
  "blockquote",
  "body",
  "br",
  "button",
  "canvas",
  "caption",
  "cite",
  "code",
  "col",
  "colgroup",
  "data",
  "datalist",
  "dd",
  "del",
  "details",
  "dfn",
  "dialog",
  "div",
  "dl",
  "dt",
  "em",
  "embed",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hgroup",
  "hr",
  "html",
  "i",
  "iframe",
  "img",
  "input",
  "ins",
  "kbd",
  "label",
  "legend",
  "li",
  "link",
  "main",
  "map",
  "mark",
  "menu",
  "meta",
  "meter",
  "nav",
  "noscript",
  "object",
  "ol",
  "optgroup",
  "option",
  "output",
  "p",
  "picture",
  "pre",
  "progress",
  "q",
  "rp",
  "rt",
  "ruby",
  "s",
  "samp",
  "script",
  "search",
  "section",
  "select",
  "slot",
  "small",
  "source",
  "span",
  "strong",
  "style",
  "sub",
  "summary",
  "sup",
  "table",
  "tbody",
  "td",
  "template",
  "textarea",
  "tfoot",
  "th",
  "thead",
  "time",
  "title",
  "tr",
  "track",
  "u",
  "ul",
  "var",
  "video",
  "wbr"
], Hn = (t) => Rn.includes(t), An = (t) => t === void 0 ? "div" : typeof t == "string" ? Hn(t) ? t : "div" : t === Ct ? t : "div", En = (t) => t === "a" || t === "button" || Zt(t), Zt = (t) => t === Ct, zt = mt.forwardRef(
  ({
    backgroundColor: t = "white",
    children: o,
    className: r = "",
    component: n = "div",
    href: f = "",
    onClick: i = () => null,
    shadow: d = !0,
    style: u = {},
    rounded: p = !0,
    width: v = "100%",
    newTab: y = !1,
    cardCapProps: x,
    "data-testid": C = "card",
    "aria-label": k
  }, M) => {
    const g = f && (wt(f) || y), O = !!x, D = An(n), A = En(D), E = Zt(D), Z = O ? /* @__PURE__ */ W(I, { flexDirection: "column", children: [
      O && /* @__PURE__ */ e(Fn, { ...x }),
      o
    ] }) : o, z = {
      className: L(r, Wt.root, {
        [Wt.shadow]: d,
        [Wt.rounded]: p
      }),
      ref: M,
      style: {
        backgroundColor: Dt(
          t,
          a.color.grayDark
        ),
        width: v,
        ...u
      },
      "data-testid": C,
      "aria-label": k
    };
    return E ? mt.createElement(
      D,
      {
        ...z,
        onClick: i,
        rel: g ? "noreferrer" : void 0,
        target: g ? "_blank" : void 0,
        to: f
      },
      Z
    ) : mt.createElement(
      D,
      {
        ...z,
        ...A ? {
          onClick: i,
          rel: g ? "noreferrer" : void 0,
          target: g ? "_blank" : void 0,
          href: f
        } : {}
      },
      Z
    );
  }
), In = ({ tag: t }) => ["a", "button"].includes(t), jn = "_buttonAdjustments_1vavw_5", Xn = "_anchorAdjustments_1vavw_38", Yn = "_pointer_1vavw_49", Un = "_fullWidth_1vavw_53", St = {
  buttonAdjustments: jn,
  anchorAdjustments: Xn,
  pointer: Yn,
  fullWidth: Un
}, Gn = oe(
  ({
    tagName: t = "button",
    children: o,
    className: r,
    disabled: n,
    fullWidth: f,
    href: i,
    onClick: d = () => null,
    testId: u,
    ...p
  }, v) => {
    const y = (g) => {
      n || d(g);
    }, x = {
      ...p,
      ...t === "button" ? { type: "button" } : {}
    }, C = !n && i ? i : void 0, k = i ? "a" : "button", M = In({ tag: t }) ? t : k;
    return /* @__PURE__ */ e(
      M,
      {
        ref: v,
        className: L(r, {
          [St.buttonAdjustments]: M === "button",
          [St.anchorAdjustments]: M === "a",
          [St.pointer]: !n,
          [St.fullWidth]: f
        }),
        disabled: n,
        onClick: y,
        href: C,
        "data-testid": u,
        ...x,
        children: o
      }
    );
  }
), qn = "_root_10kp6_1", Zn = "_noPadding_10kp6_14", jt = {
  root: qn,
  noPadding: Zn
}, ii = mt.forwardRef(
  ({ children: t, removePadding: o = !1, ...r }, n) => /* @__PURE__ */ e(
    ke,
    {
      ref: n,
      disableRipple: !0,
      disableTouchRipple: !0,
      classes: {
        root: L(jt.root, { [jt.noPadding]: o })
      },
      ...r,
      children: t
    }
  )
), Jn = ({ size: t }) => t === "large" ? "bodySm400" : "meta400", Qn = ({ size: t, children: o }) => typeof o == "string" ? /* @__PURE__ */ e(st, { variant: Jn({ size: t }), children: o }) : /* @__PURE__ */ e(vt, { children: o }), Kn = "_container_1upjo_1", Vn = "_largeContainer_1upjo_14", Pn = "_mediumContainer_1upjo_23", tr = "_smallContainer_1upjo_32", er = "_warningContainer_1upjo_41", or = "_tipContainer_1upjo_49", nr = "_successContainer_1upjo_57", rr = "_errorContainer_1upjo_65", ar = "_pendingContainer_1upjo_73", ir = "_infoContainer_1upjo_81", lr = "_readOnlyContainer_1upjo_89", sr = "_clearIcon_1upjo_97", cr = "_dismissIcon_1upjo_104", Q = {
  container: Kn,
  largeContainer: Vn,
  mediumContainer: Pn,
  smallContainer: tr,
  warningContainer: er,
  tipContainer: or,
  successContainer: nr,
  errorContainer: rr,
  pendingContainer: ar,
  infoContainer: ir,
  readOnlyContainer: lr,
  clearIcon: sr,
  dismissIcon: cr
}, Xt = Object.freeze({
  tip: {
    className: Q.tipContainer,
    icon: /* @__PURE__ */ e(F, { icon: Le })
  },
  warning: {
    className: Q.warningContainer,
    icon: /* @__PURE__ */ e(F, { icon: Te })
  },
  success: {
    className: Q.successContainer,
    icon: /* @__PURE__ */ e(F, { icon: Me })
  },
  error: {
    className: Q.errorContainer,
    icon: /* @__PURE__ */ e(F, { icon: We })
  },
  pending: {
    className: Q.pendingContainer,
    icon: /* @__PURE__ */ e(F, { icon: De })
  },
  info: {
    className: Q.infoContainer,
    icon: /* @__PURE__ */ e(F, { icon: $e })
  },
  readOnly: {
    className: Q.readOnlyContainer,
    icon: /* @__PURE__ */ e(F, { icon: Ce })
  }
}), dr = Object.freeze({
  large: Q.largeContainer,
  medium: Q.mediumContainer,
  small: Q.smallContainer
}), li = ({
  containerClass: t = "",
  children: o,
  variant: r = "tip",
  size: n = "medium",
  className: f = "",
  customIcon: i = null,
  onDismiss: d = void 0
}) => {
  const u = d !== void 0;
  return /* @__PURE__ */ W(
    I,
    {
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
      className: L(
        f,
        Q.container,
        Xt[r].className,
        dr[n],
        t
      ),
      children: [
        u ? /* @__PURE__ */ e("div", {}) : null,
        /* @__PURE__ */ W(I, { alignItems: "center", children: [
          i || Xt[r].icon,
          /* @__PURE__ */ e(Qn, { size: n, children: o })
        ] }),
        u ? /* @__PURE__ */ e(
          Gn,
          {
            testId: "dismissIcon",
            "aria-label": "Dismiss",
            onClick: d,
            className: Q.dismissIcon,
            children: /* @__PURE__ */ e(F, { className: Q.clearIcon, icon: Be })
          }
        ) : null
      ]
    }
  );
}, fr = "_loadingIcon_raaev_1", ur = "_loadingOverlay_raaev_10", mr = "_coverParent_raaev_26", hr = "_casefileVariant_raaev_33", kt = {
  loadingIcon: fr,
  loadingOverlay: ur,
  coverParent: mr,
  casefileVariant: hr
}, si = ({
  className: t = "",
  iconColor: o,
  iconType: r = "line-scale",
  coverParent: n = !1,
  variant: f = "default",
  noFadeIn: i = !1,
  paperProps: d = {},
  ...u
}) => {
  const p = Dt(o, a.color.grayDark);
  return /* @__PURE__ */ e(
    Fe,
    {
      classes: {
        root: L(kt.loadingOverlay, t, n && kt.coverParent, {
          [kt.casefileVariant]: f === "casefile"
        })
      },
      "data-testid": "loading-overlay",
      ...d,
      children: /* @__PURE__ */ e(
        Gt,
        {
          className: kt.loadingIcon,
          name: r,
          color: p,
          fadeIn: i ? "none" : "half",
          ...u
        }
      )
    }
  );
}, ci = ({ children: t }) => /* @__PURE__ */ e(ee, { theme: Ve, children: t }), Jt = () => /* @__PURE__ */ W(I, { flexDirection: "column", width: "100%", children: [
  /* @__PURE__ */ e(V, { variant: "text", width: "25%" }),
  /* @__PURE__ */ e(V, { variant: "text", width: "75%" }),
  /* @__PURE__ */ e(V, { variant: "text", width: "60%" })
] }), gr = "_root_31ksi_1", br = {
  root: gr
}, pr = ({ "data-testid": t }) => /* @__PURE__ */ e(zt, { className: br.root, "data-testid": t, children: /* @__PURE__ */ W(I, { columnGap: 1, children: [
  /* @__PURE__ */ e(V, { height: 40, width: 40, variant: "circular" }),
  /* @__PURE__ */ e(Jt, {})
] }) }), yr = "_root_31ksi_1", _r = {
  root: yr
}, xr = ({ "data-testid": t }) => /* @__PURE__ */ e(zt, { className: _r.root, "data-testid": t, children: /* @__PURE__ */ e(Jt, {}) }), wr = ({ "data-testid": t }) => /* @__PURE__ */ W(I, { columnGap: 1, alignItems: "center", "data-testid": t, children: [
  /* @__PURE__ */ e(V, { height: 32, width: 32, variant: "circular" }),
  /* @__PURE__ */ e(V, { variant: "text", width: 80, height: 24 })
] }), vr = ({ "data-testid": t }) => /* @__PURE__ */ e(I, { justifyContent: "center", "data-testId": t, children: /* @__PURE__ */ e(Gt, { color: a.color.grayLight }) }), Sr = "_card_xgnkm_1", kr = "_metaData_xgnkm_5", Mr = "_errorMessage_xgnkm_10", Tt = {
  card: Sr,
  metaData: kr,
  errorMessage: Mr
}, $r = ({
  errorMessage: t = "",
  "data-testid": o
}) => /* @__PURE__ */ e(zt, { className: Tt.card, "data-testid": o, children: /* @__PURE__ */ W(I, { flexDirection: "column", children: [
  t && /* @__PURE__ */ e(
    st,
    {
      component: "h3",
      variant: "titleSm700",
      color: "orangeDark",
      className: Tt.errorMessage,
      children: t
    }
  ),
  /* @__PURE__ */ e(V, { height: 200, variant: "rectangular" }),
  /* @__PURE__ */ W(
    I,
    {
      alignItems: "center",
      justifyContent: "space-between",
      flexShrink: "0",
      className: Tt.metaData,
      children: [
        /* @__PURE__ */ W(I, { columnGap: 1, alignItems: "center", flexGrow: 1, children: [
          /* @__PURE__ */ e(V, { width: 32, height: 32, variant: "circular" }),
          /* @__PURE__ */ W(I, { flexDirection: "column", flexGrow: 1, children: [
            /* @__PURE__ */ e(V, { height: 20, width: "75%" }),
            /* @__PURE__ */ e(V, { height: 20, width: "90%" })
          ] })
        ] }),
        /* @__PURE__ */ e(I, { alignItems: "center", justifyContent: "flex-end", flexGrow: 1, children: /* @__PURE__ */ e(V, { height: 40, width: "50%" }) })
      ]
    }
  )
] }) }), Cr = {
  listItem: pr,
  listItemText: xr,
  threeDots: vr,
  tableCellUser: wr,
  videoCard: $r
}, di = ({
  className: t = "",
  component: o = void 0,
  count: r = 1,
  "data-testid": n,
  ...f
}) => {
  const i = o ? Cr[o] : void 0;
  return Array(r).fill(0).map(
    (d) => i ? /* @__PURE__ */ e(i, { "data-testid": n }, d) : /* @__PURE__ */ e(
      V,
      {
        className: t,
        "data-testid": n,
        ...f
      },
      d
    )
  );
}, Dr = "_container_8swf9_1", Lr = "_dot_8swf9_12", Wr = "_red_8swf9_19", Tr = "_dotOutlined_8swf9_27", Br = "_gray_8swf9_33", Fr = "_orange_8swf9_47", Or = "_green_8swf9_61", zr = "_teal_8swf9_75", Nr = "_blue_8swf9_89", Rr = "_blueSteel_8swf9_103", Hr = "_yellow_8swf9_117", Ar = "_transparentBg_8swf9_132", _t = {
  container: Dr,
  dot: Lr,
  red: Wr,
  dotOutlined: Tr,
  gray: Br,
  orange: Fr,
  green: Or,
  teal: zr,
  blue: Nr,
  blueSteel: Rr,
  yellow: Hr,
  transparentBg: Ar
}, fi = ({
  className: t = "",
  color: o = "green",
  "data-testid": r,
  dot: n = !1,
  dotVariant: f = "filled",
  label: i,
  variant: d = "filled"
}) => {
  const u = _t[o === "blue-steel" ? "blueSteel" : o];
  return /* @__PURE__ */ W(
    I,
    {
      alignItems: "center",
      className: L(_t.container, u, t, {
        [_t.transparentBg]: d === "transparent"
      }),
      "data-testid": r,
      children: [
        n && /* @__PURE__ */ e(
          "div",
          {
            "data-testid": "status-lozenge-dot",
            className: L(_t.dot, {
              [_t.dotOutlined]: f === "outlined"
            })
          }
        ),
        /* @__PURE__ */ e("span", { children: i })
      ]
    }
  );
}, Er = ({
  showPassword: t,
  setShowPassword: o
}) => /* @__PURE__ */ e(Ne, { position: "end", children: /* @__PURE__ */ e(
  gt,
  {
    placement: "top",
    title: t ? "Hide Password" : "Show Password",
    children: /* @__PURE__ */ e(
      Bt,
      {
        onClick: () => o(!t),
        color: "gray",
        hasIconRight: !0,
        icon: t ? /* @__PURE__ */ e(F, { icon: Re, color: "gray" }) : /* @__PURE__ */ e(F, { icon: He, color: "gray" })
      }
    )
  }
) }), Ir = "_root_qg8p0_1", jr = "_fullWidth_qg8p0_5", Xr = "_outlinedInputRoot_qg8p0_9", Yr = "_rootLoading_qg8p0_17", Ur = "_rootWithStartAdornment_qg8p0_21", Gr = "_label_qg8p0_25", qr = "_helperTextBox_qg8p0_29", Zr = "_compactCharLimit_qg8p0_35", Jr = "_asterisk_qg8p0_46", Qr = "_hideNumberArrows_qg8p0_50", nt = {
  root: Ir,
  fullWidth: jr,
  outlinedInputRoot: Xr,
  rootLoading: Yr,
  rootWithStartAdornment: Ur,
  label: Gr,
  helperTextBox: qr,
  compactCharLimit: Zr,
  asterisk: Jr,
  hideNumberArrows: Qr
}, ui = mt.forwardRef(
  ({
    // MUI TextField base props
    variant: t = "outlined",
    rows: o = 5,
    InputLabelProps: r,
    // InputProps/inputProps must be explicitly defined here to prevent styling conflicts with MUI's default props
    InputProps: n,
    inputProps: f,
    // Character limit related props
    charLimit: i,
    enableHardLimit: d,
    // prevent user to input more characters than charLimit
    compactCharLimit: u,
    // transform charLimit styles so that it does not affect the layout
    hideNumberArrows: p,
    // Styling props
    outlinedInputClasses: v,
    rootClass: y,
    // Testing props
    testId: x,
    "data-testid": C,
    // State props
    loading: k,
    // Rest of TextField props
    value: M,
    ...g
  }, O) => {
    const [D, A] = ht(!1), E = "helper-text", Z = (M == null ? void 0 : M.length) || 0, z = i && Z > i, U = d ? (M || "").slice(0, i) : M, Y = k || !!(n != null && n.startAdornment), at = (n == null ? void 0 : n.type) === "password", et = k ? /* @__PURE__ */ e(
      F,
      {
        "data-testid": "loader-icon",
        spin: !0,
        icon: Oe,
        color: "gray"
      }
    ) : n == null ? void 0 : n.startAdornment, B = at ? /* @__PURE__ */ e(
      Er,
      {
        showPassword: D,
        setShowPassword: A
      }
    ) : n == null ? void 0 : n.endAdornment, S = () => g.defaultValue ? { defaultValue: g.defaultValue } : {}, it = {
      ...f,
      "data-testid": C || x,
      ...d && i ? { maxLength: i } : {},
      type: D ? "text" : n == null ? void 0 : n.type
    }, dt = L(nt.root, y, {
      [nt.rootWithStartAdornment]: Y,
      [nt.fullWidth]: g.fullWidth,
      [nt.rootLoading]: k,
      [nt.hideNumberArrows]: p && (n == null ? void 0 : n.type) === "number"
    }), b = () => !g.helperText && !i ? null : /* @__PURE__ */ W(vt, { children: [
      /* @__PURE__ */ e(st, { variant: "label", id: E, children: g.helperText }),
      i && /* @__PURE__ */ W(st, { variant: "label", children: [
        Z,
        "/",
        i
      ] })
    ] });
    return /* @__PURE__ */ e(
      ze,
      {
        ...S(),
        "aria-describedby": g.helperText ? E : void 0,
        ref: O,
        rows: o,
        value: U,
        variant: t,
        disabled: k || g.disabled,
        error: !!(g.error || z),
        placeholder: k ? "loading" : g.placeholder,
        classes: {
          root: dt,
          ...g.classes
        },
        FormHelperTextProps: {
          classes: {
            root: L(nt.helperTextBox, {
              [nt.compactCharLimit]: u
            })
          }
        },
        InputLabelProps: {
          shrink: !0,
          classes: { root: nt.label, asterisk: nt.asterisk },
          ...r
        },
        InputProps: {
          ...n,
          startAdornment: et,
          endAdornment: B,
          classes: {
            ...v,
            root: L(nt.outlinedInputRoot, v == null ? void 0 : v.root)
          }
        },
        inputProps: it,
        helperText: b(),
        ...g
      }
    );
  }
), Kr = "_blueHover_1dzzk_6", Vr = "_underline_1dzzk_10", Yt = {
  blueHover: Kr,
  underline: Vr
}, mi = (t) => {
  const {
    href: o = "#",
    color: r = "blueXtraDark",
    children: n,
    className: f = "",
    forceUnderline: i = !1,
    forceDisableNewTab: d = !1
  } = t, u = wt(o) ? "a" : Ct, p = { [wt(o) ? "href" : "to"]: o };
  return /* @__PURE__ */ e(
    st,
    {
      color: r,
      className: L("textLink", f, {
        [Yt.blueHover]: r === "blueXtraDark",
        [Yt.underline]: i
      }),
      component: u,
      target: d ? "_self" : "_blank",
      rel: d ? void 0 : "noreferrer",
      ...t,
      ...p,
      children: n
    }
  );
}, Pr = "_paper_gwo6v_1", ta = "_popoverContainer_gwo6v_9", ea = "_arrow_gwo6v_14", oa = "_arrowBottom_gwo6v_25", na = "_arrowTop_gwo6v_32", ra = "_arrowLeft_gwo6v_39", aa = "_arrowRight_gwo6v_46", ia = "_anchorButton_gwo6v_52", la = "_bottom_gwo6v_58", sa = "_top_gwo6v_59", ca = "_left_gwo6v_63", da = "_right_gwo6v_64", fa = "_noArrow_gwo6v_68", ua = "_hoverable_gwo6v_73", ma = "_disabled_gwo6v_74", K = {
  paper: Pr,
  popoverContainer: ta,
  arrow: ea,
  arrowBottom: oa,
  arrowTop: na,
  arrowLeft: ra,
  arrowRight: aa,
  anchorButton: ia,
  bottom: la,
  top: sa,
  left: ca,
  right: da,
  noArrow: fa,
  hoverable: ua,
  disabled: ma
}, hi = ({
  anchorContent: t = () => /* @__PURE__ */ e("button", { type: "button", children: "Anchor" }),
  "aria-label": o,
  disabled: r = !1,
  disabledMessage: n = "Disabled",
  hideArrow: f = !1,
  hoverable: i = !1,
  messagePlacement: d = "top",
  onAnchorClick: u = () => null,
  onCloseCallback: p = () => null,
  paperClass: v,
  placement: y = "bottom",
  popoverContent: x = () => /* @__PURE__ */ e("div", {}),
  tooltipProps: C,
  ...k
}) => {
  const [M, g] = ht(null), O = ne(null), D = {
    bottom: {
      anchorOrigin: { vertical: "bottom", horizontal: "center" },
      transformOrigin: { vertical: "top", horizontal: "center" }
    },
    top: {
      anchorOrigin: { vertical: "top", horizontal: "center" },
      transformOrigin: { vertical: "bottom", horizontal: "center" }
    },
    left: {
      anchorOrigin: { vertical: "center", horizontal: "left" },
      transformOrigin: { vertical: "center", horizontal: "right" }
    },
    right: {
      anchorOrigin: { vertical: "center", horizontal: "right" },
      transformOrigin: { vertical: "center", horizontal: "left" }
    }
  }, A = (Y) => {
    u(), g(M ? null : Y.currentTarget);
  }, E = () => {
    g(null), p();
  }, Z = (Y) => {
    i && g(Y.currentTarget);
  }, z = () => {
    i && (g(null), p());
  };
  return /* @__PURE__ */ W(vt, { children: [
    /* @__PURE__ */ e(
      gt,
      {
        title: !r && !(C != null && C.title) ? "" : (C == null ? void 0 : C.title) || n,
        placement: d,
        ...C,
        children: /* @__PURE__ */ e(
          "button",
          {
            "aria-expanded": !!M,
            "aria-label": o,
            "aria-owns": i && M ? "mouse-over-popover" : void 0,
            "aria-haspopup": "true",
            disabled: r,
            type: "button",
            onClick: A,
            onMouseEnter: Z,
            onMouseLeave: z,
            className: L(K.anchorButton, K[y], {
              [K.hoverable]: i,
              [K.noArrow]: f,
              [K.disabled]: r
            }),
            children: t({ disabled: r })
          }
        )
      }
    ),
    /* @__PURE__ */ e(
      Ut,
      {
        sx: i ? { pointerEvents: "none" } : void 0,
        ...D[y],
        ...k,
        id: i ? "mouse-over-popover" : void 0,
        open: !!M,
        anchorEl: M,
        anchorReference: "anchorEl",
        onClose: E,
        disableRestoreFocus: i,
        disableEnforceFocus: i,
        classes: {
          paper: L(K.paper, v)
        },
        children: /* @__PURE__ */ W("div", { className: K.popoverContainer, children: [
          !f && /* @__PURE__ */ e(
            "span",
            {
              ref: O,
              className: L(K.arrow, {
                [K.arrowBottom]: y === "bottom",
                [K.arrowTop]: y === "top",
                [K.arrowLeft]: y === "left",
                [K.arrowRight]: y === "right"
              })
            }
          ),
          x({ setAnchor: g })
        ] })
      }
    )
  ] });
};
export {
  ni as Avatar,
  qt as Badge,
  Bt as Button,
  ai as Calendar,
  zt as Card,
  Fn as CardCap,
  Gn as ClickableComponent,
  I as Flexbox,
  F as FontAwesomeIcon,
  ii as IconButton,
  li as InfoNote,
  si as LoadingOverlay,
  ci as MuiThemeProvider,
  di as Skeleton,
  fi as StatusLozenge,
  st as Text,
  ui as TextInput,
  mi as TextLink,
  gt as Tooltip,
  hi as WithPopover,
  Ie as camelCase,
  a as cssVars,
  ri as generateCssVarsPlugin,
  Ee as kebabCase,
  Ve as theme,
  bn as useMediaInfo
};
